import { ApiResourceBaseClass as n } from "./baseApiCalls.js";
const r = "categories";
class g extends n {
  /**
   * Fetch a category's data based on its ID and for a given language.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/categories/{categoryId}`
   *
   * @param {number} categoryId - The ID of the category to fetch.
   * @param {string} lang - The language to fetch the category in.
   * @returns {Promise<CategoryData>} A promise resolving to the category's data.
   */
  getCategory = async (e, t) => {
    const s = {
      lang: t,
      return_live: !0
    }, { data: a } = await this.get(
      `${r}/${e}`,
      s
    );
    return a;
  };
  /**
   * Retrieves information about available categories. Categories fetched can get narrowed down by a query string and/or a given country.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/categories?${query}&${country}&${lang}`
   *
   * @param {string} query - (Optional) The text to search for in the categories.
   * @param {string} country - (Optional) The country to search the category in.
   * @param {string} lang - (Optional) The language to fetch the category in.
   * @returns {Promise<CategoriesData>} A promise resolving to the retrieved categories' data.
   */
  getCategories = async (e, t, s) => {
    const a = {
      country: t,
      lang: s,
      search_query: e,
      live__isnull: !0,
      state: "OK",
      order_by: "-impacted_businesses"
    }, { data: i } = await this.get(`${r}`, a);
    return i;
  };
  /**
   * Retrieves the suggested categories for a given category.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/categories/{categoryId}`
   *
   * @param {number} categoryId - The ID of the category to fetch the suggested categories from.
   * @param {string} lang - The language to fetch the categories in.
   * @returns {Promise<CategoriesData>} A promise resolving to the retrieved suggested categories' data.
   */
  getSuggestedCategories = async (e, t) => {
    const s = { lang: t }, { data: a } = await this.get(
      `${r}/${e}/suggestions`,
      s
    );
    return a;
  };
}
export {
  g as Categories
};
